import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
export const CartIcon = () => {
  const {
    itemCount
  } = useCart();
  return <div className="relative inline-flex items-center" data-id="element-65">
      <ShoppingCart className="h-5 w-5" data-id="element-66" />
      {itemCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-67">
          {itemCount}
        </span>}
    </div>;
};